<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80" class="edit-win">
    <FormItem label="服务产品" prop="bdserviceid">
            <Select v-model="formValidate.bdserviceid" style="width:380px;">
                <Option v-for="item in parentbdserviceList" :key="item.id" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
    <FormItem label="模板" prop="template">
            <Select v-model="formValidate.template" style="width:380px;">
                <Option v-for="item in parenttemplateList" :key="item.id" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
    <FormItem>
      <Button @click="submitInfo" type="primary">确定</Button>
      <Button @click="$router.go(-1)" style="margin-left: 8px">返回</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {
  data () {
    return {
      isShowAp: true,
      tempPassword: '',
      formValidate: {
        bdserviceid: '',         //服务产品id
        template: '',         //模板id
        chid: '',    //车行id
        id: ''
      },
      parenttemplateList: [],
      parentbdserviceList: [],
      roleList: '',
      ruleValidate: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        againpassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        roleIdList: [
          { required: true, type: 'array', min: 1, message: '角色不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, type: 'number', message: '状态不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    '$route.query.id' () {
    },
  },
  created() {
    if(this.$route.query.id) {
      this.formValidate.chid = this.$route.query.chid
      this.formValidate.bdserviceid = Number(this.$route.query.bdserviceid)
      this.formValidate.template =Number(this.$route.query.template)
      this.formValidate.id = this.$route.query.id

      //alert(this.formValidate.template);
    }
    if(this.$route.query.groupid) {
      this.formValidate.chid = this.$route.query.groupid
    }
  },
  mounted () {
    this.gettemplateList()
    this.getbdserviceList()
    //alert(this.formValidate.template);
    //this.getDetail()
  },
  methods: {
    getDetail(){
      if(this.$route.query.id) {
        this.$Loading.start()
        this.$axios.get('/template/info/' + this.$route.query.id)
          .then(function (response) {
          if(response.data.success){
              if(!response.data.data.roleIdList) {
                response.data.data.roleIdList = []
              }
              this.formValidate = response.data.data
              this.$Loading.finish()
          }else{
            this.$Message.error(response.data.errMsg)
            this.$Loading.error()
          }
          this.table_loading = false
        }.bind(this))
      } else {
        this.formValidate.chid = this.$route.query.groupid
      }
    },
    gettemplateList(){
      this.$Loading.start()
      this.$axios.get('/template/combo')
        .then(function (response) {
        if(response.data.success){
            this.parenttemplateList = response.data.data
            this.$Loading.finish()
        }else{
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
        this.table_loading = false
      }.bind(this))
    },
    getbdserviceList(){
      this.$Loading.start()
      this.$axios.get('/bdservice/combo')
        .then(function (response) {
        if(response.data.success){
            this.parentbdserviceList = response.data.data
            this.$Loading.finish()
        }else{
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
        this.table_loading = false
      }.bind(this))
    },
    submitInfo () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$Loading.start()
          let url = ''
          this.$route.query.id ? url='template/update' : url='template/save'
          this.$axios.post(url,this.formValidate)
          .then(function (response) {
            if(response.data.success){
              this.$Message.success(response.data.data)
              this.$Loading.finish()
              this.$router.go(-1)
            }else{
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/templatepdf/edit.vue